export const DownloadCloudActive = () => (
  <>
    <g clipPath='url(#clip0_15941_3242)'>
      <path
        fill='none'
        d='M8.00005 18.9999L12.0001 22.9999M12.0001 22.9999L16.0001 18.9999M12.0001 22.9999L12.0001 13.9999M20.8801 20.0899C21.7494 19.4786 22.4014 18.6061 22.7413 17.5991C23.0813 16.5921 23.0915 15.503 22.7704 14.4898C22.4494 13.4766 21.8139 12.592 20.9561 11.9645C20.0983 11.337 19.0629 10.9991 18.0001 10.9999H16.7401C16.4393 9.82781 15.8765 8.73918 15.0942 7.81601C14.3118 6.89285 13.3302 6.15919 12.2233 5.67029C11.1163 5.18138 9.9129 4.94996 8.70358 4.99345C7.49426 5.03694 6.31057 5.3542 5.24161 5.92136C4.17265 6.48851 3.24628 7.29078 2.53224 8.26776C1.81821 9.24474 1.33511 10.371 1.11932 11.5617C0.903525 12.7524 0.960665 13.9765 1.28643 15.142C1.6122 16.3074 2.19811 17.3837 3.00005 18.2899'
        stroke='var(--pantoneBlue)'
        strokeWidth='2.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <ellipse
      cx='20'
      cy='5.5'
      rx='6'
      ry='5.5'
      fill='#00BA00'
    />
    <path
      d='M22.7596 3.21494L22.5793 3.37608L19.0166 7.3747L18.1293 6.295L17.629 5.71098C17.5881 5.66332 17.5285 5.63589 17.4658 5.63589C17.2824 5.63589 17.1833 5.85075 17.3023 5.99025L18.9409 7.91125C18.9806 7.9579 19.0527 7.95808 19.0927 7.91162L22.965 3.41667C22.9876 3.39049 23 3.35707 23 3.3225C23 3.19782 22.8525 3.13184 22.7596 3.21494Z'
      stroke='white'
    />
    <defs>
      <clipPath id='clip0_15941_3242'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(0 2)'
        />
      </clipPath>
    </defs>
  </>
)
